import { EndPoints, get, patch } from '../';
export function getConfig() {
    return get(EndPoints.config, {});
}
export function update(request) {
    return patch(EndPoints.configUpdate, request);
}
